export default function formatPdfFileName (
  organizationName: string,
  radius: number | string,
  zipCode: string,
) {
  const scrubbedName = organizationName.replace(/[\W_]+/g, '-');
  return `${scrubbedName}_${zipCode}-${radius}-mile.pdf`;
}
